import { RecommendationTemplateApi } from "~/api/RecommendationTemplate";

export function useRecommendationTemplateApi(): RecommendationTemplateApi {
    const recommendationTemplateApi = new RecommendationTemplateApi(useHttpClient());
  return recommendationTemplateApi;
}